<template>
  <!-- 新增/编辑 -->
  <el-dialog
    :title="showShop ? '选择推荐店铺' : '选择推荐商品'"
    :visible.sync="dialogVisible"
    width="960px"
    @open="open"
    :close-on-click-modal="false"
    :append-to-body="appendToBody"
  >
    <ShopAutocomplete
      ref="shopRef"
      v-if="showShop"
      @handleSelect="handleSelect"
    />
    <SelectGoods ref="selectGoodsRef" @submit="handleSubmit" :shopInfo="shopData"/>
  </el-dialog>
</template>

<script>
import ShopAutocomplete from "./shopAutocomplete";
import SelectGoods from "./selectGoods";
import {
  addRecommendGoods,
  updateRecommendGoods,
} from "@/api/recommendationHome";

export default {
  components: {
    ShopAutocomplete,
    SelectGoods,
  },
  props: {
    type: {
      type: Number,
      default: 1,
    },
    showShop: {
      type: Boolean,
      default: true,
    },
    floor: {
      type: Number,
      default: 0,
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
    shopInfo:{
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      id: "",
      dialogVisible: false,
      tableData: [],
      shopId:"",
      shopName:"",
      shopData: {}
    };
  },
  computed: {},
  watch: {
    shopInfo: {
      handler(val) {
        this.shopData = val ? {...val} : {};
      },
      deep: true,
    },
  },
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {
    open() {
      const { showShop } = this;
      this.$nextTick(() => {
        if (showShop) {
          this.$refs.shopRef.params.keyWords = this.shopName ?? "";
          if(this.shopName) {
            this.$refs.shopRef.querySearchAsync();
            this.tableData = [];
            this.$refs.selectGoodsRef.getClassify1();
            this.$refs.selectGoodsRef.searchFrom.shopId = this.shopId ?? "";
            this.$refs.selectGoodsRef.onQuery();
          }
        }
        this.$refs.selectGoodsRef.clearData();
        this.$refs.selectGoodsRef.showShop = showShop;
        !showShop && this.$refs.selectGoodsRef.getClassify1();
      });
    },
    handleSelect(row) {
      console.log(row,'row')
      this.tableData = [];
      this.$refs.selectGoodsRef.getClassify1();
      this.$refs.selectGoodsRef.searchFrom.shopId = row?.id ?? "";
      if(!this.$refs.selectGoodsRef.searchFrom.shopId) {
        this.$refs.selectGoodsRef.clearData();
      }
    },
    handleSubmit(form) {
      form.shopId =  this.$refs.selectGoodsRef.searchFrom.shopId;  
      this.dialogVisible = false;
      console.log(form,'form')
      this.$emit('choiceGoods',form)  
    },
 
  },
};
</script>
<style lang="scss" scoped>
.dialog-search {
  display: flex;
  justify-content: space-between;
}
</style>
